import api from './index'

export default {
  list(params) {
    return api.get('/admin/cars', { params })
  },
  getById(id) {
    return api.get(`/admin/cars/${id}`)
  },
  create(data) {
    return api.post('/admin/cars', data)
  },
  update(id, data) {
    return api.put(`/admin/cars/${id}`, data)
  },
  patch(id, data) {
    return api.patch(`/admin/cars/${id}`, data)
  },
  delete(id) {
    return api.delete(`/admin/cars/${id}`)
  },
  uploadImage(id, formData) {
    return api.post(`/admin/cars/${id}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }
}
